import * as React from 'react';
export const IcFashionWoman = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.74 8h8.52a5.32 5.32 0 00-.45-6l-1.41.38a1 1 0 00-.61.49 2 2 0 01-3.58 0 1 1 0 00-.61-.49L8.19 2a5.32 5.32 0 00-.45 6zm8.66 3a3.091 3.091 0 01-.4-1H8.05a3.09 3.09 0 01-.45 1C6.12 13.09 4 16.28 4 19c0 4 16 4 16 0 0-2.72-2.12-5.91-3.6-8z'
      fill='currentColor'
    />
  </svg>
);
